import React from "react";
import { cn } from "@/utils/className";

interface BackArrowButtonProps {
    label?: string;
    className?: string;
    iconSrc?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
}

export const BackArrowButton: React.FC<BackArrowButtonProps> = ({
    label = "Back",
    className,
    iconSrc = "/images/icons/icon-link-arrow.svg",
    onClick,
    disabled = false
}) => {


    return (
        <button
            type="button"
            onClick={onClick}
            className={cn("back-link-arrow cursor-pointer", className)}
            disabled={disabled}
        >
            <span className="icon">
                <img src={iconSrc} alt="" className="transform rotate-180" />
            </span>
            <span className="text">{label}</span>
        </button>
    );
};
